import React from 'react';
import { proTestimonials } from '../data/testimonials';
import { Reveal } from './Reveal';
import { TestimonialCarousel } from './TestimonialCarousel';
import { ChartUpIcon } from './icons/CraftIcons';
const proofStats = [{
  id: 's1',
  value: '45k',
  label: 'Views on one Reel'
}, {
  id: 's2',
  value: '+20%',
  label: 'Prices raised, sales up'
}, {
  id: 's3',
  value: '15',
  label: 'PDFs in the vault'
}];
export function ProProof() {
  return <section aria-labelledby="pro-proof" className="relative w-full overflow-hidden bg-ink px-4 py-10 sm:px-6 sm:py-14 lg:py-24" data-id="element-370" data-mp="2wngvofvyypjr">
      <div aria-hidden="true" className="pointer-events-none absolute -left-24 top-10 hidden h-72 w-72 rounded-full bg-sage/15 blur-3xl sm:block" data-id="element-371" data-mp="2nuwtx6kds4up" />
      <div className="relative mx-auto max-w-[1120px]" data-id="element-372" data-mp="2rtm2mluh4y80">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-373" data-mp="3fkrih10ezqib">
          <span className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-gold-light" data-id="element-374" data-mp="3kc16jx6bels3">
            <ChartUpIcon className="h-3.5 w-3.5" data-id="element-375" data-mp="332uzyafqwx3y" />
            The bonuses in action
          </span>
          <h2 id="pro-proof" className="mt-4 font-display text-3xl font-bold leading-tight text-cream sm:text-[38px]" data-id="element-376" data-mp="3hrr621y8s01x">
            The makers who treated it like a business.
          </h2>
          <p className="mt-3 text-sm text-cream/60 sm:text-base" data-id="element-377" data-mp="3qrw95zwekcaa">
            Same $27. They used the SEO secrets, the hooks, the branding kit and the calculator.
          </p>
        </Reveal>

        <Reveal delay={0.12} className="mt-6 sm:mt-9" data-id="element-378" data-mp="4lr0jm5hl223">
          <TestimonialCarousel items={proTestimonials} tone="dark" labelledBy="pro-proof" data-id="element-379" data-mp="4j4uxs25owmi" />
        </Reveal>

        <div className="mt-7 grid gap-3 sm:mt-10 sm:grid-cols-3 sm:gap-4" data-id="element-380" data-mp="3vppgwxdcteco">
          {proofStats.map((stat, index) => <Reveal key={stat.id} delay={index * 0.08} data-id="element-381" data-mp="21dr8gxmvcmhu" data-mpi={index}>
              <div className="rounded-2xl border border-cream/10 bg-cream/5 px-5 py-6 text-center" data-id="element-382" data-mp="21fc2mm59u3f6">
                <p className="font-display text-4xl font-extrabold text-gold-light" data-id="element-383" data-mp="5c7a136fdh3k">{stat.value}</p>
                <p className="mt-1 text-[11px] font-bold uppercase tracking-[0.12em] text-cream/55" data-id="element-384" data-mp="a9pmv4nkcggu">
                  {stat.label}
                </p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}